/**
 * @returns {*}
 */
function ip () {
  return /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/
}

module.exports = { ip }
